import { FormLabel, TextField } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { Controller, type Control } from 'react-hook-form';
import type { BookLongTextFieldName, BookToBeCreated } from '../types';

type BookTextAreaFieldProps = {
  control: Control<BookToBeCreated>;
  name: BookLongTextFieldName;
  labelId: string;
  defaultMessage: string;
  minRows?: number;
};

const BookTextAreaField = ({ control, name, labelId, defaultMessage, minRows = 3 }: BookTextAreaFieldProps) => {
  const intl = useIntl();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <>
            <FormLabel htmlFor={`book-${name}`}>
              <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
            </FormLabel>
            <TextField
              {...field}
              id={`book-${name}`}
              value={field.value ?? ''}
              variant="outlined"
              fullWidth
              multiline
              minRows={minRows}
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
              placeholder={intl.formatMessage({ id: 'book.modern.fieldPlaceholder' })}
              sx={{
                '& .MuiInputBase-root': {
                  height: 'auto',
                  alignItems: 'flex-start',
                },
                '& textarea': { lineHeight: 1.6 },
              }}
            />
          </>
        );
      }}
    />
  );
};

export default BookTextAreaField;
